var _a;
import { EventSubscriber } from '@verdant-web/common';
import { filterResultSet } from './utils.js';
import { Entity } from '../reactives/Entity.js';
import { Disposable } from '../utils/Disposable.js';
export const ON_ALL_UNSUBSCRIBED = Symbol('ON_ALL_UNSUBSCRIBED');
export const UPDATE = Symbol('UPDATE');
export class BaseQuery extends Disposable {
    constructor({ initial, context, collection, key, shouldUpdate, }) {
        super();
        this._internalUnsubscribes = [];
        this._status = 'initial';
        this._executionPromise = null;
        this.subscribe = (callback) => {
            // accessing for side effects... eh
            this.resolved;
            return this._events.subscribe('change', callback);
        };
        this.setValue = (value) => {
            this._rawValue = value;
            this.subscribeToDeleteAndRestore(this._rawValue);
            this._value = filterResultSet(value);
            this._status = 'ready';
            this._events.emit('change', this._value);
        };
        // re-applies filtering if results have changed
        this.refreshValue = () => {
            this.setValue(this._rawValue);
        };
        this.subscribeToDeleteAndRestore = (value) => {
            var _b;
            while (this._internalUnsubscribes.length) {
                (_b = this._internalUnsubscribes.pop()) === null || _b === void 0 ? void 0 : _b();
            }
            if (Array.isArray(value)) {
                value.forEach((entity) => {
                    if (entity instanceof Entity) {
                        this._internalUnsubscribes.push(entity.subscribe('delete', this.refreshValue));
                        this._internalUnsubscribes.push(entity.subscribe('restore', this.refreshValue));
                    }
                });
            }
            else if (value instanceof Entity) {
                this._internalUnsubscribes.push(value.subscribe('delete', this.refreshValue));
                this._internalUnsubscribes.push(value.subscribe('restore', () => {
                    this.refreshValue();
                }));
            }
        };
        this.execute = () => {
            this.context.log('debug', 'Executing query', this.key);
            this._status = 'running';
            this._executionPromise = this.run().then(() => this._value);
            return this._executionPromise;
        };
        this[_a] = (handler) => {
            this._allUnsubscribedHandler = handler;
        };
        this._rawValue = initial;
        this._value = initial;
        this._events = new EventSubscriber((event) => {
            var _b;
            if (event === 'change')
                (_b = this._allUnsubscribedHandler) === null || _b === void 0 ? void 0 : _b.call(this, this);
        });
        this.context = context;
        this.key = key;
        this.collection = collection;
        const shouldUpdateFn = shouldUpdate ||
            ((collections) => collections.includes(collection));
        this.addDispose(this.context.entityEvents.subscribe('collectionsChanged', (collections) => {
            if (shouldUpdateFn(collections)) {
                this.context.log('info', 'Updating query', this.key);
                this.execute();
            }
        }));
    }
    get current() {
        return this._value;
    }
    get resolved() {
        var _b;
        if (this.status === 'ready')
            return Promise.resolve(this._value);
        return (_b = this._executionPromise) !== null && _b !== void 0 ? _b : this.execute();
    }
    get subscribed() {
        return this._events.totalSubscriberCount() > 0;
    }
    get status() {
        return this._status;
    }
}
_a = ON_ALL_UNSUBSCRIBED;
//# sourceMappingURL=BaseQuery.js.map